import React, { useState, useCallback } from 'react';
import { DndProvider } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { 
  Database, 
  Settings, 
  Mail, 
  Calendar, 
  FileText, 
  Users, 
  BarChart3, 
  Zap,
  ArrowDown,
  X
} from 'lucide-react';
// Removed LeftColumn, CenterColumn, RightColumn imports
import StackerEducatorTool from './components/StackerEducatorTool'; // Import the new component

// Available assets/actions with icons (these are now part of the StackerEducatorTool's context if needed)
const availableAssets = [
  { id: 'database', name: 'Database Connection', icon: Database, description: 'Connect to data sources' },
  { id: 'api', name: 'API Integration', icon: Zap, description: 'External API calls' },
  { id: 'email', name: 'Email Service', icon: Mail, description: 'Send notifications' },
  { id: 'calendar', name: 'Calendar Events', icon: Calendar, description: 'Schedule management' },
  { id: 'reports', name: 'Report Generator', icon: FileText, description: 'Generate documents' },
  { id: 'users', name: 'User Management', icon: Users, description: 'Handle user data' },
  { id: 'analytics', name: 'Analytics', icon: BarChart3, description: 'Data analysis' },
  { id: 'settings', name: 'Configuration', icon: Settings, description: 'System settings' }
];

function App() {
  // droppedItems state and related handlers are no longer needed in App.js
  // as StackerEducatorTool will manage its own state and interactions.
  const [droppedItems, setDroppedItems] = useState([]);

  const handleDrop = useCallback((item) => {
    setDroppedItems(prev => {
      // Prevent duplicates
      if (prev.find(dropped => dropped.id === item.id)) {
        return prev;
      }
      return [...prev, item];
    });
  }, []);

  const removeItem = useCallback((itemId) => {
    setDroppedItems(prev => prev.filter(item => item.id !== itemId));
  }, []);

  return (
    <DndProvider backend={HTML5Backend}>
      {/* Replaced the dashboard layout with the new StackerEducatorTool */}
      <StackerEducatorTool />
    </DndProvider>
  );
}

export default App;